<ul class="flex flex-col gap-2 pr-1">
  @for (file of files(); track $index) {
    <li
      class="flex items-center justify-between gap-3 rounded-lg border border-gray-100 bg-white px-4 py-3 text-gray-800 shadow-sm">
      <div class="flex min-w-0 items-center gap-3">
        <svg aria-hidden="true" class="size-5 shrink-0 text-gray-600">
          <use href="@dashboard-web-order/icons/file-document.svg#file-document"></use>
        </svg>

        <span class="min-w-0 truncate font-medium">{{ file.name }}</span>
      </div>

      <button
        type="button"
        class="flex size-7 shrink-0 items-center justify-center rounded-md text-gray-600 transition hover:bg-gray-100 hover:text-gray-900"
        title="Datei entfernen"
        (click)="onClickRemove(file, $index)">
        <svg aria-hidden="true" class="size-4">
          <use href="@dashboard-web-order/icons/x.svg#x"></use>
        </svg>
      </button>
    </li>
  }
</ul>
